import React from "react";
import { NavLink } from "react-router-dom";

export default function FrontPage() {
    return (
        <>
            <style jsx>
                {`
                    /*--------------------------------------------------------------
# Front
--------------------------------------------------------------*/

                    /*--------------------------------------------------------------
# Sections
--------------------------------------------------------------*/
                    section {
                        padding: 60px 0;
                        overflow: hidden;
                    }

                    .section-header {
                        text-align: center;
                        padding-bottom: 40px;
                    }

                    .section-header h2 {
                        font-size: 13px;
                        letter-spacing: 1px;
                        font-weight: 700;
                        margin: 0;
                        /* color: #4154f1; */
                        text-transform: uppercase;
                    }

                    .section-header p {
                        margin: 10px 0 0 0;
                        padding: 0;
                        font-size: 38px;
                        line-height: 42px;
                        font-weight: 700;
                        /* color: #0d0d0e; */
                    }

                    @media (max-width: 768px) {
                        .section-header p {
                            font-size: 28px;
                            line-height: 32px;
                        }
                    }

                    /*--------------------------------------------------------------
# Breadcrumbs
--------------------------------------------------------------*/
                    .breadcrumbs {
                        padding: 15px 0;
                        background: #f6f4f0;
                        min-height: 40px;
                        margin-top: 82px;
                        color: #fff;
                    }

                    @media (max-width: 992px) {
                        .breadcrumbs {
                            margin-top: 57px;
                        }
                    }

                    .breadcrumbs h2 {
                        font-size: 28px;
                        font-weight: 500;
                    }

                    .breadcrumbs ol {
                        display: flex;
                        flex-wrap: wrap;
                        list-style: none;
                        padding: 0 0 10px 0;
                        margin: 0;
                        font-size: 14px;
                    }

                    .breadcrumbs ol a {
                        color: #fff;
                        transition: 0.3s;
                    }

                    .breadcrumbs ol a:hover {
                        text-decoration: underline;
                    }

                    .breadcrumbs ol li + li {
                        padding-left: 10px;
                    }

                    .breadcrumbs ol li + li::before {
                        display: inline-block;
                        padding-right: 10px;
                        /* color: #8894f6; */
                        content: "/";
                    }

                    /*--------------------------------------------------------------
# Disable aos animation delay on mobile devices
--------------------------------------------------------------*/
                    @media screen and (max-width: 768px) {
                        [data-aos-delay] {
                            transition-delay: 0 !important;
                        }
                    }

                    /*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
                    .header {
                        transition: all 0.5s;
                        z-index: 997;
                        padding: 20px 0;
                    }

                    .header.header-scrolled {
                        background: #fff;
                        padding: 15px 0;
                        box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);
                    }

                    .header .logo {
                        line-height: 0;
                    }

                    .header .logo img {
                        max-height: 55px;
                        margin-right: 6px;
                    }

                    .header .logo span {
                        font-size: 30px;
                        font-weight: 700;
                        letter-spacing: 1px;
                        /* color: #012970; */
                        margin-top: 3px;
                    }

                    /*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
                    /**
* Desktop Navigation 
*/
                    .navbar {
                        padding: 0;
                    }

                    .navbar ul {
                        margin: 0;
                        padding: 0;
                        display: flex;
                        list-style: none;
                        align-items: center;
                    }

                    .navbar li {
                        position: relative;
                    }

                    .navbar a,
                    .navbar a:focus {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 10px auto;
                        font-family: "Ubuntu", sans-serif;
                        font-size: 16px;
                        font-weight: 300;
                        color: #000000;
                        white-space: nowrap;
                        transition: 0.3s;
                    }

                    .navbar a i,
                    .navbar a:focus i {
                        font-size: 12px;
                        line-height: 0;
                        margin-left: 5px;
                    }

                    .navbar a:hover,
                    .navbar .active,
                    .navbar .active:focus,
                    .navbar li:hover > a {
                        color: #000000;
                    }

                    .navbar .getstarted,
                    .navbar .getstarted:focus {
                        /* background: #4154f1; */
                        padding: 8px 20px;
                        margin-left: 30px;
                        border-radius: 4px;
                        color: #fff;
                    }

                    .navbar .getstarted:hover,
                    .navbar .getstarted:focus:hover {
                        color: #fff;
                        background: #5969f3;
                    }

                    .navbar .dropdown ul {
                        display: block;
                        position: absolute;
                        left: 14px;
                        top: calc(100% + 30px);
                        margin: 0;
                        padding: 10px 0;
                        z-index: 99;
                        opacity: 0;
                        visibility: hidden;
                        background: #fff;
                        box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
                        transition: 0.3s;
                        border-radius: 4px;
                    }

                    .navbar .dropdown ul li {
                        min-width: 200px;
                    }

                    .navbar .dropdown ul a {
                        padding: 10px 20px;
                        font-size: 15px;
                        text-transform: none;
                        font-weight: 600;
                    }

                    .navbar .dropdown ul a i {
                        font-size: 12px;
                    }

                    .navbar .dropdown ul a:hover,
                    .navbar .dropdown ul .active:hover,
                    .navbar .dropdown ul li:hover > a {
                        color: #008080;
                    }

                    .navbar .dropdown:hover > ul {
                        opacity: 1;
                        top: 100%;
                        visibility: visible;
                    }

                    .navbar .dropdown .dropdown ul {
                        top: 0;
                        left: calc(100% - 30px);
                        visibility: hidden;
                    }

                    .navbar .dropdown .dropdown:hover > ul {
                        opacity: 1;
                        top: 0;
                        left: 100%;
                        visibility: visible;
                    }

                    .nav-link:hover {
                        border-bottom: 1px solid black;
                    }

                    @media (max-width: 1366px) {
                        .navbar .dropdown .dropdown ul {
                            left: -90%;
                        }

                        .navbar .dropdown .dropdown:hover > ul {
                            left: -100%;
                        }
                    }

                    /**
* Mobile Navigation 
*/
                    .mobile-nav-toggle {
                        /* color: #48AFC6; */
                        font-size: 28px;
                        cursor: pointer;
                        display: none;
                        line-height: 0;
                        transition: 0.5s;
                    }

                    .mobile-nav-toggle.bi-x {
                        color: #fff;
                    }

                    @media (max-width: 991px) {
                        .mobile-nav-toggle {
                            display: block;
                        }

                        /* .navbar ul {
        display: none;
    } */
                    }

                    .navbar-mobile {
                        position: fixed;
                        overflow: hidden;
                        top: 0;
                        right: 0;
                        left: 0;
                        bottom: 0;
                        /* background: rgba(1, 22, 61, 0.9); */
                        transition: 0.3s;
                    }

                    .navbar-mobile .mobile-nav-toggle {
                        position: absolute;
                        top: 15px;
                        right: 15px;
                    }

                    .navbar-mobile ul {
                        display: block;
                        position: absolute;
                        top: 55px;
                        right: 15px;
                        bottom: 15px;
                        left: 15px;
                        padding: 10px 0;
                        border-radius: 10px;
                        background-color: #fff;
                        overflow-y: auto;
                        transition: 0.3s;
                    }

                    .navbar-mobile a,
                    .navbar-mobile a:focus {
                        padding: 10px 20px;
                        font-size: 15px;
                        color: #000000;
                    }

                    .navbar-mobile a:hover,
                    .navbar-mobile .active,
                    .navbar-mobile li:hover > a {
                        color: #226d7f;
                    }

                    .navbar-mobile .getstarted,
                    .navbar-mobile .getstarted:focus {
                        margin: 15px;
                    }

                    .navbar-mobile .dropdown ul {
                        position: static;
                        display: none;
                        margin: 10px 20px;
                        padding: 10px 0;
                        z-index: 99;
                        opacity: 1;
                        visibility: visible;
                        background: #fff;
                        box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
                    }

                    .navbar-mobile .dropdown ul li {
                        min-width: 200px;
                    }

                    .navbar-mobile .dropdown ul a {
                        padding: 10px 20px;
                    }

                    .navbar-mobile .dropdown ul a i {
                        font-size: 12px;
                    }

                    .navbar-mobile .dropdown ul a:hover,
                    .navbar-mobile .dropdown ul .active:hover,
                    .navbar-mobile .dropdown ul li:hover > a {
                        color: #226d7f;
                    }

                    .navbar-mobile .dropdown > .dropdown-active {
                        display: block;
                    }

                    /*  */
                    /*  */
                    .heading-text {
                        font-size: 60px !important;
                        font-weight: bold;
                        color: #323232;
                    }

                    .heading-desc {
                        font-size: 24px;
                        line-height: normal;
                        color: #323232;
                    }

                    .heading-top {
                        margin-top: 8%;
                    }

                    .back-color-front-page {
                        background-color: #fff;
                    }

                    .front-page-back-color {
                        background-color: #f6f4f0;
                        padding-bottom: 20%;
                        /* height: 52rem; */
                    }

                    .about-laptop-img {
                        position: absolute;
                        left: 27%;
                    }

                    .about-bws {
                        font-size: 40px !important;
                    }

                    .about-bws-desc {
                        font-size: 20px;
                    }

                    .bws-paragraph-desc {
                        line-height: 1.6em;
                        text-align: justify;
                        font-size: 18px;
                    }

                    .about-medical-claim {
                        color: #00ff64;
                        font-size: 18px;
                        line-height: 1.7em;
                        text-align: center;
                        letter-spacing: 0.15em;
                        width: 30%;
                        position: relative;
                        left: 36%;
                    }

                    .about-claim-back-color {
                        background-color: rgb(50 50 50);
                    }

                    .bws-desc {
                        line-height: 1.6em;
                        font-size: 18px;
                    }

                    .bws-card {
                        height: 24rem;
                        width: 62%;
                        margin-left: 19%;
                        background: #323232;
                        color: #fff;
                    }

                    .bws-card-title {
                        padding: 15% 0% 2% 8%;
                        line-height: normal;
                        font-size: 21px;
                    }

                    .bws-border-line {
                        border: 2px solid #00ff64;
                        width: 13%;
                    }

                    .post-title-div {
                        padding: 8%;
                    }

                    .bws-card-text {
                        color: #fff;
                        font-size: 15px;
                    }

                    .bws-ul-list {
                        list-style-type: disc;
                    }

                    .bws-about-back-section {
                        padding-top: 15%;
                        padding-bottom: 10rem;
                    }

                    .bws-service-page-back-color {
                        background: #f6f4f0;
                    }

                    .bws-service-back-section {
                        padding-bottom: 10rem;
                        background-color: #f6f4f0;
                    }

                    .bws-specialty-back-section {
                        padding-bottom: 10rem;
                        /* background-color: #fafafa; */
                    }

                    .bws-card-speciality {
                        height: 25rem;
                        width: 78%;
                        background: #fff;
                        margin-left: 1%;
                        border-radius: 15px;
                        box-shadow: 1px 3px 2px 4px #f8edec;
                    }

                    .bws-card-text-speciality {
                        font-size: 15px;
                    }

                    .client-title-bws {
                        font-size: 27px;
                        color: #fff;
                        margin-top: 2%;
                    }

                    .bws-contact-back-color {
                        background-color: #323232;
                        height: 5rem;
                        border-radius: 12px;
                    }

                    .text-receive-email {
                        text-align: left;
                        color: #00f561;
                    }

                    .bws-contact-input-padding {
                        padding: 20px;
                    }

                    .bws-btn-enter {
                        background: #fff;
                        border-radius: 7px;
                        padding: 5px 30px 5px 30px;
                        cursor: pointer;
                    }

                    .contact-back-color {
                        background-color: #fff;
                        padding-bottom: 10rem;
                    }

                    .bws-footer-desc {
                        font-size: 16px;
                        line-height: 1.7em;
                        text-align: center;
                        color: #c6c6c6;
                    }

                    .bws-footer-copy-right {
                        line-height: 1.6em;
                        text-align: center;
                        font-size: 16px;
                    }

                    /* Media Query */
                    @media (max-width: 1440px) {
                        .front-laptop-img {
                            position: relative;
                            width: 115%;
                            right: 26%;
                        }

                        .bws-about-back-section {
                            padding: 24% 10% 8% 4%;
                        }

                        .navbar {
                            right: 10%;
                        }
                    }

                    @media (max-width: 1024px) {
                        .back-color-front-page {
                            width: 81rem;
                        }

                        .bws-about-back-section {
                            padding: 35% 3% 8% 1%;
                        }
                    }

                    @media (max-width: 768px) {
                        .front-page-back-color {
                            padding-bottom: 10%;
                        }

                        .about-laptop-img {
                            position: relative;
                            left: 14%;
                            width: 61%;
                        }

                        .bws-about-back-section {
                            padding: 0;
                            margin-left: 0;
                        }

                        .bws-desc-about {
                            margin-top: 10%;
                        }

                        .about-medical-claim {
                            left: 20%;
                        }

                        .bws-service-back-section {
                            margin: 0;
                            padding: 3rem;
                        }

                        .bws-specialty-back-section {
                            margin: 0;
                            padding: 3rem;
                        }

                        .contact-back-color {
                            margin-left: 9%;
                        }

                        .client-786-row {
                            margin-left: -13%;
                        }

                        .client-title-bws {
                            font-size: 20px;
                            margin-top: 33px;
                        }

                        .bws-card-speciality {
                            margin-top: 15%;
                        }
                    }

                    @media (max-width: 425px) {
                        .navbar {
                            margin-left: 41rem;
                        }

                        .header-top {
                            display: block !important;
                        }

                        .heading-desc {
                            width: 35%;
                            margin-top: 2rem !important;
                        }

                        .front-laptop-img {
                            position: relative;
                            width: 71%;
                            right: 44%;
                            height: 43%;
                        }

                        .about-bws-desc {
                            font-size: 18px;
                        }

                        .bws-desc-about {
                            margin-top: 5%;
                            width: 36%;
                        }

                        .about-medical-claim {
                            left: 4%;
                        }

                        .bws-service-back-section {
                            margin: 0;
                            padding: 10px;
                        }

                        .bws-service-w {
                            width: 39%;
                        }

                        .bws-card {
                            width: 30%;
                            margin-left: 3%;
                        }

                        .bws-card-speciality {
                            height: 23rem;
                            width: 33%;
                        }

                        .bws-card-speciality {
                            margin-top: 4%;
                        }

                        .client-786-row {
                            margin-left: 7%;
                        }

                        .client-title-bws {
                            font-size: 27px;
                            margin-top: 1%;
                        }

                        .zhang-link,
                        .zhang-link:visited,
                        .zhang-link:hover,
                        .zhang-link:active {
                            color: #fff;
                        }

                        .contact-back-color {
                            margin-left: -62%;
                        }

                        /* .contact-back-color {
        margin-left: 1%;
    } */

                        .footer-newsletter {
                            width: 22%;
                            margin-left: 39%;
                        }

                        .text-receive-email {
                            font-size: 12px;
                            margin-top: 7px;
                        }

                        .about-claim-left {
                            margin-left: -62%;
                        }
                    }

                    @media (max-width: 375px) {
                        .heading-text {
                            font-size: 47px !important;
                        }

                        .heading-desc {
                            width: 32%;
                        }

                        .front-laptop-img {
                            position: relative;
                            width: 56%;
                            height: 15%;
                            right: 47%;
                        }

                        .about-bws-desc {
                            font-size: 16px;
                        }

                        .bws-desc-about {
                            margin-top: 5%;
                            width: 32%;
                        }

                        .about-medical-claim {
                            left: 2%;
                        }

                        .bws-service-w {
                            width: 35%;
                        }

                        .bws-card {
                            width: 28%;
                            margin-left: 2%;
                        }

                        .bws-card-speciality {
                            height: 24rem;
                            width: 27%;
                        }

                        .client-786-row {
                            margin-left: 6%;
                        }

                        /*  */
                        .footer-newsletter {
                            width: 31%;
                        }

                        .text-receive-email {
                            font-size: 11px;
                            margin-top: 7px;
                        }

                        .bws-btn-enter {
                            padding: 5px 15px 5px 15px;
                        }

                        .contact-back-color {
                            margin-left: -67%;
                        }

                        .footer-newsletter {
                            width: 18%;
                            margin-left: 41%;
                        }

                        .about-claim-left {
                            margin-left: -67%;
                        }
                    }

                    .navbar ul {
                        position: relative;
                        right: 86%;
                    }

                    @media (max-width: 320px) {
                        .navbar a {
                            font-size: 13px;
                        }

                        .navbar ul {
                            right: 88%;
                        }

                        .heading-desc {
                            width: 28%;
                        }

                        .front-laptop-img {
                            position: relative;
                            width: 51%;
                            height: 20%;
                            right: 51%;
                        }

                        .about-bws-desc {
                            font-size: 13px;
                        }

                        .bws-desc-about {
                            margin-top: 5%;
                            width: 27%;
                        }

                        .about-medical-claim {
                            left: 2%;
                            width: 25%;
                        }

                        .bws-service-w {
                            width: 30%;
                        }

                        .bws-card {
                            width: 23%;
                            margin-left: 2%;
                        }

                        .bws-card-title {
                            padding: 15% 0% 2% 2%;
                        }

                        .bws-card-speciality {
                            height: 26rem;
                            width: 22%;
                        }

                        .client-786-row {
                            margin-left: 4%;
                        }

                        .contact-back-color {
                            margin-left: -72%;
                        }

                        .about-claim-left {
                            margin-left: -71%;
                        }

                        .bws-footer-desc {
                            font-size: 14px;
                        }

                        .bws-footer-copy-right {
                            font-size: 14px;
                        }
                    }
                `}
            </style>

            <div className="back-color-front-page">
                {/* <header id="header" className="header fixed-top header-back-color front-page-back-color"> */}
                <header id="header" className="header header-back-color">
                    <div className="container-fluid container-xl d-flex align-items-center justify-content-between header-top">
                        <a className="logo d-flex align-items-center">
                            <img className="" src="/assets/img/logo/mini_logo1.png" alt="Header-mini-logo" />
                            <img className="" src="/assets/img/logo/logo_header.png" alt="Header-logo" />
                        </a>
                        <nav id="navbar" className="navbar">
                            <ul className="display-ul-max">
                                <li>
                                    <a className="nav-link scrollto">Home</a>
                                </li>

                                <li>
                                    <a className="nav-link scrollto">BWS Service</a>
                                </li>

                                <li>
                                    <NavLink className="nav-link scrollto" to="/login">
                                        Login
                                    </NavLink>
                                </li>
                            </ul>
                            <i className="bi bi-list mobile-nav-toggle"></i>
                        </nav>
                    </div>
                </header>

                <section id="hero" className="front-page-back-color hero d-flex align-items-center">
                    <div className="container-fluid container-xl align-items-center justify-content-between heading-top">
                        <h2 className="heading-text">BILL WITH US</h2>
                        <p className="heading-desc mt-3">We pride ourselves on great service providing an effective and powerful way to grow your business</p>

                        <div className="text-center mt-5 about-laptop-img">
                            <img
                                className="front-laptop-img"
                                src="https://static.wixstatic.com/media/e96012_0c7d8a3b089c461aa60ec8eb233120f4~mv2.png/v1/crop/x_631,y_809,w_4656,h_3163/fill/w_887,h_602,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/webpage.png"
                                width="887px"
                                height="602px"
                            />
                        </div>
                    </div>
                </section>

                {/*  */}
                <div className="container bws-about-back-section">
                    <div className="col-lg-12 col-md-12 p-5">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <h3 className="fw-bold about-bws">ABOUT BWS</h3>
                                <p className="about-bws-desc mt-3">WE ARE MORE THAN A BILLING COMPANY</p>
                            </div>
                            <div className="col-lg-6 col-md-12 bws-desc-about">
                                <span className="bws-paragraph-desc">
                                    BWS Service, LLC. was established in November 2021, with the members of billing experts, doctors, lawyers, software developers, and the marketing team. Our goal is
                                    to make sure you succeed not only in medical billing but in business. If you don't get paid, we do not get paid. This means if your business grows, we grow too.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="col-lg-12 col-md-12 about-claim-back-color">
                    <p className="about-medical-claim">There are 187,043 dental practices in the U.S. and only less than 1% are filing medical claims</p>
                </section>

                {/* BWS SERVICE */}
                <section id="hero" className="bws-service-page-back-color hero d-flex align-items-center">
                    <div className="container mt-5 bws-service-back-section">
                        <div className="row">
                            <div className="bws-service-w">
                                <h3 className="fw-bold about-bws">BWS SERVICE</h3>
                                <p className="bws-desc mt-4">Many experts in each field, came together to create the best medical billing system.</p>
                                <p className="bws-desc">It's easy, safe, and secure.</p>
                            </div>
                        </div>

                        <div className="row row-cols-1 row-cols-md-1 row-cols-xxl-2 g-5 mt-5">
                            <div className="col">
                                <div className="post-box card-bg bws-card">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">ELIGIBILITY CHECK </h3>
                                            <p className="border-bws"></p>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <p className="bws-card-text">24/7 Live Insurance verification</p>
                                                <p className="bws-card-text">done in 1 minute!</p>
                                                <p className="bws-card-text">No More Phone Calls.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="post-box card-bg bws-card">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">5 MINUTES CLAIM</h3>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <p className="bws-card-text">Only billable codes are shown</p>
                                                <p className="bws-card-text">in the portal. Dental terms</p>
                                                <p className="bws-card-text">are automatically converted</p>
                                                <p className="bws-card-text">to medicare codes.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="post-box card-bg bws-card">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">FOLLOW UP</h3>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <p className="bws-card-text">We take care of co-insurance</p>
                                                <p className="bws-card-text">and rejected claims.</p>
                                                <p className="bws-card-text">Just send the claim to us,</p>
                                                <p className="bws-card-text">we will do the rest.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="post-box card-bg bws-card">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">MARKETING</h3>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <span className="bws-card-text">Check out our marketing features.</span>
                                                <ul>
                                                    <li className="bws-ul-list">Social Media</li>
                                                    <li className="bws-ul-list">Filming</li>
                                                    <li className="bws-ul-list">Postcard</li>
                                                    <li className="bws-ul-list">Website</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* BWS SPECIALTY */}
                <section className="container bws-specialty-back-section">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <h3 className="fw-bold about-bws">BWS SPECIALTY</h3>
                        </div>
                    </div>

                    <div className="row g-5 mt-5">
                        <div className="row">
                            <div className="col-lg-4 col-md-6  ">
                                <div className="post-box card-bg bws-card-speciality">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">PPO BILLING </h3>
                                            <p className="border-bws"></p>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <p className="bws-card-text-speciality">Bill to any medical insurance at any age.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 ">
                                <div className="post-box card-bg bws-card-speciality">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">NOTE GENERATION</h3>
                                            <p className="border-bws"></p>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <p className="bws-card-text-speciality">
                                                    Our new coming software will generate 80% of your surgical note automatically. It will save you hours and hours.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6  ">
                                <div className="post-box card-bg bws-card-speciality">
                                    <div className="section-data mx-4">
                                        <div>
                                            <h3 className="bws-card-title fw-bold">AUDIT SUPPORT </h3>
                                            <p className="border-bws"></p>
                                        </div>
                                        <div className="post-title-div">
                                            <div className="bws-border-line"></div>
                                            <div className="mt-5">
                                                <p className="bws-card-text-speciality">Medicare defense insurance audit redetermination forms.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/*  */}
                <section className="col-lg-12 col-md-12 about-claim-back-color">
                    <div className="container">
                        <div className="col-lg-12">
                            <div className="row client-786-row">
                                <div className="col-lg-2"></div>
                                <div className="col-lg-3 col-md-3">
                                    <h3>
                                        <a href="https://www.jpdentalgroup.com/" target="_blank" rel="noreferrer noopener">
                                            <img src="https://static.wixstatic.com/media/e96012_052f061bf0fc4a58a02da36f401995db~mv2.png/v1/fill/w_181,h_92,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/jp%20dental%20implant%20logo_webp.png" />
                                        </a>
                                    </h3>
                                </div>
                                <div className="col-lg-3 col-md-3">
                                    <h3>
                                        <a href="https://www.youtube.com/c/Gpointbetterthancash" target="_blank" rel="noreferrer noopener">
                                            <img src="https://static.wixstatic.com/media/e96012_1fa9a0b1deb9442388a8234ffa9311e1~mv2.png/v1/crop/x_8,y_67,w_272,h_143/fill/w_186,h_98,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/gpoint%20logo%20white.png" />
                                        </a>
                                    </h3>
                                </div>
                                <div className="col-lg-3 col-md-3 client-title-bws">
                                    <h3>
                                        <a href="https://www.zhangdds.com/" target="_blank" rel="noreferrer noopener">
                                            <span className="zhang-link" style={{ fontSize: 27, color: "#fdfdfd" }}>
                                                Dr J Zhang DDS
                                            </span>
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <section className="col-lg-12 col-md-12 about-claim-back-color about-claim-left">
                    <div className="container">
                        <div className="col-lg-12 col-md-6">
                            <div className="row text-center">
                                <a href="https://www.bizapedia.com/addresses/9980-s-300-w-sandy-ut-84070.html" target="_blank" rel="noreferrer noopener">
                                    <p className="bws-footer-desc">9980 S 300 W Suite 200 Sandy, UT 84070</p>
                                </a>
                                <p className="bws-footer-copy-right">&copy; 2022 by BWS Service, LLC.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
